import React, { useRef } from "react";
import { connect } from "react-redux";

import {
  getUserLocation,
  getUserPermissionById,
  getUserRole,
} from "../../redux";
import { useGetAllStationDisplays } from "../../hooks";

import { HubHookFormWrapper, PageContent } from "../../components";
import DisplaysMenu from "./DisplaysMenu";
import DisplayPageContent from "./DisplayPageContent";
import { CreateDisplayDialog } from "../../dialogs";
import EditDisplayDialog from "../../dialogs/EditDisplayDialog/EditDisplayDialog";

import { StyledContentStack, StyledDisplayStack } from "./styles";
import { DisplaysProvider, useDisplaysContext } from "./DisplayContextProvider";
import DisplayDeleteConfirm from "./DisplayDeleteConfirm";
import { DisplayPageBar } from "../../containers";
import {
  PERMISSION_LEVEL_KEYS,
  PERMISSIONS_KEY,
} from "../../constants/permissions";

const mapStateToProps = (state) => ({
  defaultNav: getUserPermissionById(
    state,
    PERMISSIONS_KEY.MODELS,
    PERMISSION_LEVEL_KEYS.VIEW_ONLY
  ),
  defaultLocation: getUserLocation(state),
});

const DisplaysPageContent = () => {
  const { defaultNav, locationId } = useDisplaysContext();
  const gridRef = useRef(null);

  const { isLoading } = useGetAllStationDisplays(locationId);

  const WithoutNav = (
    <>
      <StyledContentStack barHidden={!defaultNav}>
        <DisplaysMenu />
        <StyledDisplayStack barHidden={!defaultNav} ref={gridRef}>
          <DisplayPageContent gridRef={gridRef} />
        </StyledDisplayStack>
      </StyledContentStack>
      <CreateDisplayDialog />
    </>
  );

  const WithNav = (
    <>
      <HubHookFormWrapper>
        <DisplayPageBar />
        {WithoutNav}
        <EditDisplayDialog />
        <DisplayDeleteConfirm />
      </HubHookFormWrapper>
    </>
  );

  return (
    <PageContent isLoading={isLoading} disablePadding white id="display-page">
      {defaultNav ? WithNav : WithoutNav}
    </PageContent>
  );
};

export const DisplaysPage = connect(mapStateToProps)(
  ({ defaultNav, defaultLocation }) => (
    <DisplaysProvider defaultNav={defaultNav} defaultLocation={defaultLocation}>
      <DisplaysPageContent />
    </DisplaysProvider>
  )
);

export default DisplaysPage;
